import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getBestListDialerByAfid } from 'actions'
import {isEmpty, isNull} from 'lodash'
import Icon from '../../../DashboardBokningV2/img/crown.svg';
import { ReactComponent as IconDev } from '../../../DashboardBokningV2/img/crown.svg';
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

function mapStateToProps({auth,DashBoard}) {
    const { authUser} = auth;
    const { BestListDialer,DashboardDialerFilterOption} = DashBoard;
    return {
        authUser,BestListDialer,DashboardDialerFilterOption
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getBestListDialerByAfid: (Afid,userid,FilterOption) => dispatch(getBestListDialerByAfid(Afid,userid,FilterOption)),
        dispatch
    }
}
const ColorCode=[

    '#DAA520',
    '#C0C0C0',
    '#b08d57'
]
const ShadowCode=[

    '0px 0px 15px #DAA520',
    '0px 0px 9px #C0C0C0',
    '0px 0px 9px #b08d57'
]
const MarginCode=[

    // '0px',
    '22px',
    '22px',
    '22px'
]
const DefaultValue = [

    {
        FirstName:"No.1",
        total:0,
    },
    {
        FirstName:"No.2",
        total:0,
    },
    {
        FirstName:"No.3",
        total:0,
    },
]
const DefaultValue1 = [
    {
        FirstName:"No.2",
        total:0,
    },
    {
        FirstName:"No.3",
        total:0,
    },
]
const DefaultValue2 = [
    {
        FirstName:"No.3",
        total:0,
    },
]


class TopSellers extends Component {
    state={
        BestListDialer:0,
        DashboardDialerFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getBestListDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })        

    }
    
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getBestListDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            30000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    componentDidUpdate=()=>{
        /*
        if(this.props.DashboardDialerFilterOption !== this.state.DashboardDialerFilterOption && !isEmpty(this.props.DashboardDialerFilterOption))
           {
                
               const Afid = this.props.Afid;
               this.props.getBestListDialerByAfid(Afid).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             })
               this.setState({
                DashboardDialerFilterOption:this.props.DashboardDialerFilterOption 
               }) 
           }
           */
        }
    formatNumber=(number)=>{
        console.log(number)
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else{
            return number
        }
    }

    componentDidUpdate=()=>{

        if(this.state.BestListDialer !== this.props.BestListDialer){
            this.setState({
                BestListDialer:this.props.BestListDialer
            })
        }
    }
    render() {
        console.log('test12345678', this.state.BestListDialer)  
        // function newArray() {
        // let arr = this.state.BestListDialer
        // [arr[0], arr[1]] = [arr[1], arr[0]]
        
        // console.log('test12345678', arr)
        // }

        // console.log('test12345678', this.state.BestListDialer.sort(function(x,y){ return x == first ? -1 : y == first ? 1 : 0; }))  

        return (
            <div style={{ color: 'white' }}>
                <div className="text-center">
                    <h2 style={{ paddingTop: '12px', margin: '0' }}><b><IntlMessages id="DashBoard.TopList"/></b></h2>
                    <p><IntlMessages id="Month.Current"/></p>
                </div>
                <div className="d-flex row" style={{ marginTop: this.props.circleHeight === 110 ? '-1rem' : '0px' }}>
                    {
                         this.state.done === false?  
                         <>
                         <div className={`col-4`} style={{ marginTop: this.props.circle === 150 ? '2rem' : '1.5rem' }}>
                             <div className={`d-flex justify-content-center`}>
                             <div className="text-center" >
                                 <Skeleton variant="circle" width={150} height={150} />
                             </div>                    
                             </div>
                             <div>
                             <p className="d-flex justify-content-center"
                             style={{marginTop:'5px',  marginBottom:'0',paddingBottom:'10px'}}
                             >
                             <Skeleton variant="rectangular" width={100} height={30} />
                             </p>
                                 <p className="d-flex justify-content-center" 
                                 style={{fontSize:20, marginTop:'-4px'}}>
                                 <Skeleton variant="rectangular" width={100} height={20} />
                                 </p>
                             </div>
                         </div>
                         <div className={`col-4`} style={{ marginTop: this.props.circle === 150 ? '2rem' : '1.5rem' }}>
                             <div className={`d-flex justify-content-center`}>
                             <div className="text-center" >
                                 <Skeleton variant="circle" width={150} height={150} />
                             </div>                    
                             </div>
                             <div>
                             <p className="d-flex justify-content-center"
                             style={{marginTop:'5px',  marginBottom:'0',paddingBottom:'10px'}}
                             >
                             <Skeleton variant="rectangular" width={100} height={30} />
                             </p>
                                 <p className="d-flex justify-content-center" 
                                 style={{fontSize:20, marginTop:'-4px'}}>
                                 <Skeleton variant="rectangular" width={100} height={20} />
                                 </p>
                             </div>
                         </div>
                         <div className={`col-4`} style={{ marginTop: this.props.circle === 150 ? '2rem' : '1.5rem' }}>
                             <div className={`d-flex justify-content-center`}>
                             <div className="text-center" >
                                 <Skeleton variant="circle" width={150} height={150} />
                             </div>                    
                             </div>
                             <div>
                             <p className="d-flex justify-content-center"
                             style={{marginTop:'5px',  marginBottom:'0',paddingBottom:'10px'}}
                             >
                             <Skeleton variant="rectangular" width={100} height={30} />
                             </p>
                                 <p className="d-flex justify-content-center" 
                                 style={{fontSize:20, marginTop:'-4px'}}>
                                 <Skeleton variant="rectangular" width={100} height={20} />
                                 </p>
                             </div>
                         </div>
                         </>
                         : 
                    isEmpty(this.state.BestListDialer)?
                    DefaultValue.map((object,index) =>
                    <div className="col-4" style={{ marginTop:'1rem' }}>
                        <div className="d-flex justify-content-center">
                            <div className="text-center" 
                            style={{ 
                                position: 'relative',
                                backgroundColor: 'transparent', 
                                // backgroundColor: '#075a5f', 
                                width: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                                height: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                                // width: '120px', 
                                // height: '120px', 
                                border: `6px solid ${ColorCode[index]}`, 
                                borderRadius: '100px',
                                boxShadow:`5px 5px 8px #00000040`,
                                marginTop:`${MarginCode[index]}`,
                                // boxShadow:`0px 0px 15px  ${ColorCode[index]}`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center'
                                }}>
                                <p style={{ fontSize: this.props.fontSizeTopp > 1 ? this.props.fontSizeTopp : 50, marginTop: this.props.circleHeight === 120 ? '1rem' : '0.5rem' }}>
                                {`?`}
                                </p>
                                {
                                    index === 0 ?
                                        <>
                                        {
                                            process.env.NODE_ENV === 'development' ?
                                            <IconDev style={{ height: this.props.circleHeight === 120 ? '30px' : '25px', width: 'auto', position: 'absolute', top:'-27%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                            </IconDev>
                                            :
                                            <Icon style={{ height: this.props.circleHeight === 120 ? '30px' : '25px', width: 'auto', position: 'absolute', top:'-27%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                            </Icon>
                                        }
                                        <span style={{color: '#000', fontWeight: '700', fontSize: 18, position: 'absolute', top:'-22%', left: '50%', transform: 'translateX(-50%)',}}>1</span>
                                        </>
                                    :   ''
                                }
                                {
                                    index === 1 ?
                                        <div style={{ height: this.props.circleHeight === 120 ? 30 : 25, width: this.props.circleHeight === 120 ? 30 : 25, borderRadius: '50%', backgroundColor: '#C0C0C0', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>2</span>
                                        </div>
                                    :   ''
                                }
                                {
                                    index === 2 ?
                                        <div style={{ height: this.props.circleHeight === 120 ? 30 : 25, width: this.props.circleHeight === 120 ? 30 : 25, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                        </div>
                                    :   ''
                                }
                            </div>
                        </div>
                        <div>
                            <p className="d-flex justify-content-center" style={{ marginBottom:'0', fontSize: this.props.fontSizeToppNr >10 ? this.props.fontSizeToppNr : 30, fontWeight: '400' }}>
                            {/* <p className="d-flex justify-content-center" style={{ marginBottom:'0', fontSize:30}}> */}
                            {this.formatNumber(parseInt(object.total))}
                            </p>
                            <p className="d-flex justify-content-center" style={{fontSize:this.props.fontSizeToppName > 1 ? this.props.fontSizeToppName : 15, marginTop:'-4px'}}>
                            {/* <p className="d-flex justify-content-center" style={{fontSize:15, marginTop:'-4px'}}> */}
                            {`${object.FirstName}`}    
                            </p>
                        </div>
                    </div>
                )
                    :       
                    // splice(index + 1, 0, arr.splice(index, 1)[0]                 
                    this.state.BestListDialer.map((object,index) =>
                        <div className="col-4" style={{marginTop:'1rem'}}>
                            <div className="d-flex justify-content-center">
                                <div className="text-center" style={{ 
                                position: 'relative',
                                backgroundColor: isNull(object.ProfilePicUrl) ? 'transparent' : '', 
                                width: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                                height: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                                border: `6px solid ${ColorCode[index]}`, 
                                borderRadius: '100px',
                                boxShadow:`5px 5px 8px #00000040`,
                                marginTop:`${MarginCode[index]}`,
                                // boxShadow:`0px 0px 15px  ${ColorCode[index]}`,
                                backgroundImage: 'url('+object.ProfilePicUrl+')',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center'
                                }}>
                                    <p style={{ fontSize: this.props.fontSizeTopp > 1 ? this.props.fontSizeTopp : 50, marginTop: this.props.circleHeight === 120 ? '1rem' : '0.5rem' }}>{
                                    isNull(object.ProfilePicUrl) ?(
                                        `${object.FirstName[0]}${isEmpty(object.LastName)?"":object.LastName[0]}`):''
                                    }</p>
                                    {
                                        index === 0 ?
                                            <>
                                            {
                                                process.env.NODE_ENV === 'development' ?
                                                <IconDev style={{ height: this.props.circleHeight === 120 ? '30px' : '25px', width: 'auto', position: 'absolute', top:'-27%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                                </IconDev>
                                                :
                                                <Icon style={{ height: this.props.circleHeight === 120 ? '30px' : '25px', width: 'auto', position: 'absolute', top:'-27%', left: '50%', transform: 'translateX(-50%)', color: '#DAA520'}}>
                                                </Icon>

                                            }
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18, position: 'absolute', top:'-22%', left: '50%', transform: 'translateX(-50%)',}}>1</span>
                                            </>
                                        :   ''
                                    }
                                    {
                                        index === 1 ?
                                            <div style={{ height: this.props.circleHeight === 120 ? 30 : 25, width: this.props.circleHeight === 120 ? 30 : 25, borderRadius: '50%', backgroundColor: '#C0C0C0', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>2</span>
                                            </div>
                                        :   ''
                                    }
                                    {
                                        index === 2 ?
                                            <div style={{ height: this.props.circleHeight === 120 ? 30 : 25, width: this.props.circleHeight === 120 ? 30 : 25, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                            </div>
                                        :   ''
                                    }
                                </div>
                            </div>
                            <div>
                                <p className="d-flex justify-content-center" style={{ marginBottom:'0', fontSize: this.props.fontSizeToppNr >10 ? this.props.fontSizeToppNr : 30, fontWeight: '400' }}>
                                    {this.formatNumber(parseInt(object.total))}
                                </p>
                                <p className="d-flex justify-content-center" style={{fontSize:this.props.fontSizeToppName > 1 ? this.props.fontSizeToppName : 15, marginTop:'-4px'}}>
                                {`${object.FirstName} ${isEmpty(object.LastName)?"":object.LastName}`}
                                </p>
                            </div>
                        </div>
                    )
                    }
                     {
                    isEmpty(this.state.BestListDialer)?"":
                   (this.state.BestListDialer.length === 1)?
                   DefaultValue1.map((object,index) =>
                   <div className="col-4" style={{ marginTop:'1rem' }}>
                       <div className="d-flex justify-content-center">
                           <div className="text-center" 
                           style={{ 
                               position: 'relative',
                               backgroundColor: 'transparent', 
                               width: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                               height: this.props.circleHeight > 40 ? this.props.circleHeight : 120, 
                               border: `6px solid ${ColorCode[index+1]}`, 
                               borderRadius: '100px',
                               boxShadow:`5px 5px 8px #00000040`,
                               marginTop:`${MarginCode[index+1]}`,
                            //    boxShadow:`0px 0px 15px  ${ColorCode[index+1]}`,
                               backgroundSize: 'cover',
                               backgroundPosition: 'center'
                               }}>
                               <p style={{ fontSize: this.props.fontSizeTopp > 1 ? this.props.fontSizeTopp : 50, marginTop: this.props.circleHeight === 120 ? '1rem' : '0.5rem' }}>
                               {`?`}
                               </p>
                               {
                                    index === 0 ?
                                        <div style={{ height: this.props.circleHeight === 120 ? 30 : 25, width: this.props.circleHeight === 120 ? 30 : 25, borderRadius: '50%', backgroundColor: '#C0C0C0', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>2</span>
                                        </div>
                                    :   ''
                                }
                                {
                                    index === 1 ?
                                        <div style={{ height: this.props.circleHeight === 120 ? 30 : 25, width: this.props.circleHeight === 120 ? 30 : 25, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                        </div>
                                    :   ''
                                }
                           </div>
                       </div>
                       <div>
                           <p className="d-flex justify-content-center" style={{ marginBottom:'0', fontSize: this.props.fontSizeToppNr >10 ? this.props.fontSizeToppNr : 30, fontWeight: '400' }}>
                           {this.formatNumber(parseInt(object.total))}
                           </p>
                           <p className="d-flex justify-content-center" style={{fontSize:this.props.fontSizeToppName > 1 ? this.props.fontSizeToppName : 15, marginTop:'-4px'}}>
                           {`${object.FirstName}`}    
                           </p>
                       </div>
                   </div>
               ):
               (this.state.BestListDialer.length === 2)?
               DefaultValue2.map((object,index) =>
               <div className="col-4" style={{ marginTop:'1rem' }}>
                   <div className="d-flex justify-content-center">
                       <div className="text-center" 
                       style={{ 
                           position: 'relative',
                           backgroundColor: 'transparent', 
                           width: this.props.circleHeight > 40 ? this.props.circleHeight : 100, 
                           height: this.props.circleHeight > 40 ? this.props.circleHeight : 100, 
                           border: `6px solid ${ColorCode[index+2]}`, 
                           borderRadius: '100px',
                           boxShadow:`5px 5px 8px #00000040`,
                           marginTop:`${MarginCode[index+2]}`,
                        //    boxShadow:`0px 0px 15px  ${ColorCode[index+2]}`,
                           backgroundSize: 'cover',
                           backgroundPosition: 'center'
                           }}>
                           <p style={{ fontSize: this.props.fontSizeTopp > 1 ? this.props.fontSizeTopp : 50, marginTop: this.props.circleHeight === 120 ? '1rem' : '0.5rem' }}>
                           {`?`}
                           </p>
                           {
                                index === 0 ?
                                    <div style={{ height: this.props.circleHeight === 120 ? 30 : 25, width: this.props.circleHeight === 120 ? 30 : 25, borderRadius: '50%', backgroundColor: '#b08d57', position: 'absolute', top:'-20%', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <span style={{color: '#000', fontWeight: '700', fontSize: 18}}>3</span>
                                    </div>
                                :   ''
                            }
                       </div>
                   </div>
                   <div>
                       <p className="d-flex justify-content-center" style={{ marginBottom:'0', fontSize: this.props.fontSizeToppNr >10 ? this.props.fontSizeToppNr : 30, fontWeight: '400' }}>
                       {this.formatNumber(parseInt(object.total))}
                       </p>
                       <p className="d-flex justify-content-center" style={{fontSize:this.props.fontSizeToppName > 1 ? this.props.fontSizeToppName : 15, marginTop:'-4px'}}>
                       {`${object.FirstName}`}    
                       </p>
                   </div>
               </div>
):""
                   
                }
                </div>
            </div>
        ) 
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
)(TopSellers);
